import { keyframes, Stack } from "@mui/material";
import {
  SrTheme,
  ThemeMode,
  type ResolvedThemeMode,
  useResolvedGlobalThemeMode,
} from "@shuttlerock/mui-components";
import LoadingSvg from "./Loading.svg";

const LOADING_BACKGROUND_COLORS = {
  [ThemeMode.Light]: SrTheme.colorSchemes.light?.palette.background?.default as string,
  [ThemeMode.Dark]: SrTheme.colorSchemes.dark?.palette.background?.default as string,
} satisfies Record<ResolvedThemeMode, string>;

// The mark is drawn with `currentColor`, and this splash paints its own
// background before the themed tree is up, so pin the matching ink per scheme —
// otherwise the mark can inherit a colour that vanishes against it.
const LOADING_MARK_COLORS = {
  [ThemeMode.Light]: SrTheme.colorSchemes.light?.palette.text?.primary as string,
  [ThemeMode.Dark]: SrTheme.colorSchemes.dark?.palette.text?.primary as string,
} satisfies Record<ResolvedThemeMode, string>;

const pulse = keyframes`
    0%, 100% {
        transform: scale(0.95);
        opacity: 0.6;
    }

    70% {
        transform: scale(1);
        opacity: 1;
    }
`;

export const Loading = () => {
  const resolvedMode = useResolvedGlobalThemeMode();
  const backgroundColor = LOADING_BACKGROUND_COLORS[resolvedMode];
  const markColor = LOADING_MARK_COLORS[resolvedMode];

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        position: "absolute",
        inset: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor,
        color: markColor,
        svg: {
          display: "block",
          margin: "auto",
          maxWidth: "144px",
          animation: `${pulse} 2s infinite`,
        },
      }}
    >
      <LoadingSvg />
    </Stack>
  );
};
